import { DtoExt } from '@/classes/scenario/DtoExt';
import { FeedInPricingTypeRef } from '@/dto/scenario/eco/EcoReference';
import { GridPricingFileExt } from '@/classes/scenario/eco/GridPricingFileExt';

export class FeedInExt extends DtoExt {
  public feedInTariff: number | null;
  public feedInDuration: number | null;
  public feedInTariffEscalationRate: number | null;
  public feedInTariff2: number | null;
  public feedInTariffEscalationRate2: number | null;
  public hasPaymentForExcessAnnualGeneration: boolean | null;
  public feedInPricingTypeRef: FeedInPricingTypeRef | null;
  public feedInFlexibleTariff: GridPricingFileExt;
  public feedInPPAvsMerchant: number | null;
  public feedInMerchantPriceVector: boolean | null;
  public routeToMarket: number | null;

  constructor(options: Partial<FeedInExt> = {}) {
    super();
    this.feedInTariff = options?.feedInTariff ?? null;
    this.feedInDuration = options?.feedInDuration ?? null;
    this.feedInTariffEscalationRate = options?.feedInTariffEscalationRate ?? null;
    this.feedInTariff2 = options?.feedInTariff2 ?? null;
    this.feedInTariffEscalationRate2 = options?.feedInTariffEscalationRate2 ?? null;
    this.hasPaymentForExcessAnnualGeneration = options?.hasPaymentForExcessAnnualGeneration ?? null;
    this.feedInPricingTypeRef = options?.feedInPricingTypeRef ?? null;
    this.feedInFlexibleTariff = options?.feedInFlexibleTariff ?? new GridPricingFileExt();
    this.feedInPPAvsMerchant = options?.feedInPPAvsMerchant ?? 1;
    this.feedInMerchantPriceVector = options.feedInMerchantPriceVector ?? false;
    this.routeToMarket = options?.routeToMarket ?? null;
  }
}
